// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.finger-pointer{\n    position: fixed;\n    bottom: 50px;\n    right: 70px;\n    z-index: 1000;\n    opacity: 0;\n    pointer-events: none\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
